var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupActiveCodeStatisticsDetail-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "活码明细",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            width: "30%",
            "close-on-press-escape": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.close
          }
        },
        [
          _c("div", { staticClass: "activeCode-name" }, [
            _vm._v(" 活码名称: "),
            _c("span", { staticClass: "name" }, [
              _vm._v(" " + _vm._s(_vm.activeCodeName))
            ])
          ]),
          _vm._l(_vm.detailData, function(item, index) {
            return _c("div", { key: index, staticClass: "data-list-wrap" }, [
              _c("div", { staticClass: "data-item-title" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      "群聊" + (index + 1) + "：" + (item.chatName || "--")
                    ) +
                    " "
                )
              ]),
              _c("div", { staticClass: "data-item-content" }, [
                _c("div", { staticClass: "data-item" }, [
                  _vm._v(
                    " 进群人数：" +
                      _vm._s(
                        item.joinChatGroupNum != null ||
                          item.joinChatGroupNum != undefined
                          ? item.joinChatGroupNum
                          : 0
                      ) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "data-item" }, [
                  _vm._v(
                    " 退群人数：" +
                      _vm._s(
                        item.exitChatGroupNum != null ||
                          item.exitChatGroupNum != undefined
                          ? item.exitChatGroupNum
                          : 0
                      ) +
                      " "
                  )
                ]),
                _c("div", { staticClass: "data-item" }, [
                  _vm._v(
                    " 当前群人数：" +
                      _vm._s(
                        item.currentGroupNum != null ||
                          item.currentGroupNum != undefined
                          ? item.currentGroupNum
                          : 0
                      ) +
                      " "
                  )
                ])
              ])
            ])
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }